import { Box, Tag, Wrap, WrapItem } from '@chakra-ui/react';
import { Tooltip } from '@/components/ui/tooltip';
import { useQueryClient } from '@tanstack/react-query'
import { FiLock } from 'react-icons/fi'
import { useRemoveTag } from '../../hooks/useContactDetail'
import { KIND_META } from './attendeeTagKind'
import type { AttendeeTagDto, AttendeeTagKind } from '../../types/lobbyDay'

// Wave 3 (C.2): Andrew — "having a record of a past meeting there is all we need".
// Display-only trim: these tags are still minted and still drive follow-up lists,
// door-script text and List Builder targeting. Do NOT stop projecting them.
const HIDDEN_KINDS: ReadonlySet<AttendeeTagKind> = new Set(['Ask', 'Outcome'])

export function AttendeeTagChips({ tags, contactId, eventId }: { tags: AttendeeTagDto[]; contactId: string; eventId: string }) {
  const removeTag = useRemoveTag(contactId)
  const qc = useQueryClient()
  const visible = tags.filter((t) => !HIDDEN_KINDS.has(t.kind))
  if (visible.length === 0) return null
  return (
    <Wrap gap={1}>
      {visible.map((t) => {
        const meta = KIND_META[t.kind]
        // `system` (not kind) is the single source of truth for locked/removable —
        // an unrecognized LobbyDay label classifies as Conduct yet is system=true.
        return (
          <WrapItem key={t.tagId}>
            <Tag.Root size="sm" colorPalette={meta.color} variant="subtle">
              {t.system && (
                <Tooltip content="Managed automatically — follows attendance & outcomes">
                  <Box as="span" display="inline-flex">
                    <Tag.StartElement boxSize="10px" asChild><FiLock /></Tag.StartElement>
                  </Box>
                </Tooltip>
              )}
              <Tag.Label>{t.label}</Tag.Label>
              {!t.system && (
                <Tag.CloseTrigger aria-label={`Remove tag ${t.label}`}
                  onClick={() => removeTag.mutate(t.tagId, {
                    onSuccess: () => qc.invalidateQueries({ queryKey: ['lobby-day', 'attendees', eventId] }),
                  })} />
              )}
            </Tag.Root>
          </WrapItem>
        );
      })}
    </Wrap>
  );
}
